/**
 * 1stdibs
 * User: James
 * Date: 1/17/14
 */
"use strict";

var SoaCollection = require('bunsen/collections/SoaCollection');
var DimensionSet = require('bunsen/models/inventory/DimensionSet');
var endpoints = require('dibs-endpoints');
var _ = require('underscore');
var getDeferredMethods = require('bunsen/helpers/getDeferredMethods');
var dataProvider = require('bunsen/helpers/dataProvider');
var globalCache = require('bunsen/helpers/globalCache');

var Deferred = getDeferredMethods().Deferred;

var cacheKey = Symbol('fetching_dimension_sets_all');

/**
 * @class DimensionSets
 * @extends SoaCollection
 */
var DimensionSets = module.exports = SoaCollection.extend();

_.extend(DimensionSets.prototype, /** @lends DimensionSets.prototype */{
    url: endpoints.dimensionSets,
    model: DimensionSet
});

/**
 * @public
 * @memberOf DimensionSets
 * @returns {DimensionSets}
 */
DimensionSets.allDimensionSets = function () {
    if (!DimensionSets._allDimensionSets) {
        DimensionSets._allDimensionSets = new DimensionSets();
    }
    return DimensionSets._allDimensionSets;
};

/**
 * @public
 * @memberOf DimensionSets
 * @param {object} [fetchOptions] Same options you would pass to SoaCollection.fetch 
 * @returns {Deferred.promise}
 */
DimensionSets.fetchAllDimensionSets = function (fetchOptions) {
    var allDimSetsProm = globalCache.get(cacheKey);
    if (!allDimSetsProm) {
        allDimSetsProm = DimensionSets.allDimensionSets().fetch(fetchOptions);
        globalCache.set(cacheKey, allDimSetsProm);
        allDimSetsProm.fail(function () {
            globalCache.del(cacheKey);
        });
    }
    return allDimSetsProm;
};

/**
 * Returns a promise of the completed 'allDimensionSets' singleton
 * instance. If the dataProvider has data for the dimension sets
 * available, that data is used for the collection. Otherwise,
 * the collection is fetched from the service.
 * @public
 * @memberOf DimensionSets
 * @param {object} [fetchOptions] Same options you would pass to SoaCollection.fetch 
 * @param {string} [dataProviderKey] Key param used to retrieve data from dataProvider
 * @returns {Deferred.promise}
 */
DimensionSets.requestAllDimensionSetsUseDP = function (fetchOptions, dataProviderKey) {
    var data = dataProvider.get(dataProviderKey || 'dimension_sets');
    if (data) {
        DimensionSets.allDimensionSets().reset(data);
        return new Deferred().resolve(data).promise();
    }
    return DimensionSets.fetchAllDimensionSets(fetchOptions);
};



// WEBPACK FOOTER //
// ./~/bunsen/collections/inventory/DimensionSets.es.js